module.exports = __webpack_public_path__ + "03_long_beige.ce4fb5e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/03_long_beige.png
// module id = 9cKf
// module chunks = 0